import Promise from 'bluebird';

export function loadGoogleAPIScript(url = 'https://accounts.google.com/gsi/client') {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  }).timeout(120000, 'Google API not inited in 2 minutes');
}
